import { createLink, type LinkProps as TLinkProps } from "@tanstack/react-router";
import MuiLink, { type LinkProps as MuiLinkProps } from "@mui/material/Link";


type LinkProps = {
	tab?: boolean;
} & MuiLinkProps & TLinkProps;

const CustomLink = createLink(MuiLink);

export default function Link({ tab, ...props }: LinkProps) {
	return <CustomLink underline="none" target={tab ? "_blank" : undefined} {...props} />;
}